import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Partic from './partic';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await fetch('https://cairomed-backend.vercel.app/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password })
      });
      
      const data = await response.json();
      console.log(data);
      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }
      
      if (data.status === 'success' && data.token) {
        // Store user data in session storage
        if (data.data && data.data.user) {
          sessionStorage.setItem('user', JSON.stringify(data.data.user));
        }
        
        // Set cookie to expire in 7 days
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        document.cookie = `auth_token=${data.token}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Strict`;
        
        // Redirect based on user role
        if (data.data?.user?.role === 'admin'||data.data?.user?.role === 'accountant'||data.data?.user?.role === 'storekeeper') {
          navigate('/Dashboard');
        } else if (data.data?.user?.role === 'representative') {
          navigate('/RepProfile');
        }
      } else {
        throw new Error('Invalid response or no token received');
      }
    } catch (error) {
      setError(error.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Partic />
      <div className="login-container">
        <div className="login-form-container">
          <h2>Login</h2>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;